export default __webpack_public_path__ + "static/media/Team-profile-generator-screenshot.9cd582c6.png";